/* unplugin-vue-components disabled */import script from "./UnusedTierConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnusedTierConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import "./UnusedTierConfirmModal.vue?vue&type=style&index=0&id=328cff32&lang=less"
import "./UnusedTierConfirmModal.vue?vue&type=style&index=1&id=328cff32&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-328cff32"]])

export default __exports__